<template>
    <div class="my-4">
        <h5>Webpage Templates</h5>
        <div><span class="badge text-bg-light">(ready made web pages to jump start your project)</span></div>

        <div class="d-flex flex-wrap mt-1 mb-4" :class="model.isMobile ? 'justify-content-center' : ''">

            <a v-for="websiteTemplate in model.websiteTemplates" href="javascript:void(0)"
               @click="onTemplateClick(websiteTemplate)" class="no-underline  my-1">

                <div class="card h-100 shadow mx-3 my-2 d-flex align-items-start flex-column" style="width: 18rem;">

                    <img v-if="websiteTemplate.featured_image" :src="websiteTemplate.featured_image"
                         class="card-img-top mb-auto">

                    <svg v-else class="bd-placeholder-img card-img-top" width="100%" height="180"
                         xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid slice" focusable="false"
                         role="img" aria-label="Placeholder: Image cap">
                        <title>Placeholder</title>
                        <rect width="100%" height="100%" fill="#868e96"></rect>
                        <text x="50%" y="50%" fill="#dee2e6" dy=".3em">Screenshot Not Available</text>
                    </svg>

                    <h5 class="card-title ms-3 mt-2">{{websiteTemplate.name}}</h5>
                </div>
            </a>


            <!--            <div v-for="appTemplate in model.appTemplates" class="p-3">-->
            <!--                <a href="javascript:void(0)" @click="onTemplateClick(appTemplate)" class="no-underline">-->
            <!--                    <app-display :app="appTemplate"></app-display>-->
            <!--                </a>-->
            <!--            </div>-->
        </div>

        <webpage-template-modal v-if="showTemplateModal" @noEvent="showTemplateModal = false"
                                :yesEvent="onSiteImport"
                                :website-template="currentSiteTemplate"></webpage-template-modal>

        <!--        <model-template-modal v-if="showTemplateModal" @noEvent="showTemplateModal = false"-->
        <!--                              :yesEvent="onAppImport" :app-template="currentAppTemplate"></model-template-modal>-->
    </div>
</template>

<script>
    import WebsiteTemplateService from "../services/WebsiteTemplateService";
    import SiteService from "../services/SiteService";
    import WebpageTemplateModal from "./WebpageTemplateModal.vue";

    export default {
        name: 'WebpageTemplates',
        components: {WebpageTemplateModal},
        data() {
            return {
                model: webase.model,
                siteTemplateService: new WebsiteTemplateService(),
                siteService: new SiteService(),
                showTemplateModal: false,
                currentSiteTemplate: null,
                onSiteImport: function () {
                }
            }
        },
        mounted() {
            this.siteTemplateService.list().then((websiteTemplates) => {
                this.model.websiteTemplates = websiteTemplates
            }).catch((error) => {
                console.log('Error loading website templates.')
                console.log(error)
            })
        },
        methods: {
            onTemplateClick(siteTemplate) {

                this.currentSiteTemplate = siteTemplate
                this.showTemplateModal = true

                this.onSiteImport = () => {
                    this.siteService.copyPages(this.model.website.slug, this.currentSiteTemplate.slug).then((website) => {
                        console.log('Copied pages into website from template.')
                        console.log(website)
                        // this.$router.push({name: 'open-app', params: {id: app.id}})
                        this.$router.push({ name: 'open-site', params: {id: this.model.website.slug}})
                    }).catch((error) => {
                        console.log('Error copying pages into website from template.')
                        console.log(error)
                    })
                }
            }
        }
    }
</script>

<style>

</style>
